import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /schema
 */
export default class SchemaClient extends CRUD {
	constructor() {
		super('/schema');
	}

	create() {
		throw new Error('Not supported');
	}

	update() {
		throw new Error('Not supported');
	}

	delete() {
		throw new Error('Not supported');
	}
}
